module.exports = __webpack_public_path__ + "static/media/office5.99ffc11c.jpg";